import { render, staticRenderFns } from "./manage-leave-applications.vue?vue&type=template&id=81f8ac76"
import script from "./manage-leave-applications.vue?vue&type=script&lang=js"
export * from "./manage-leave-applications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports